import React from 'react';
import { Card, Form, Input, Button, Typography, Row } from 'antd';
import { Link } from 'react-router-dom';
import axios from 'axios';
import CareHiresLogo from '../../assets/img/CH_New_Logo.png';
import './ForgotPassword.css';
import Toaster, { showToast } from '../Toaster/Toaster';
const { Title, Text } = Typography;

const ForgotPassword: React.FC = () => {

  const onFinish = async (values: any) => {
    try {
      const response = await axios.post(
        `${import.meta.env.VITE_AUTH_API_URL}/api/v1/auth/users/password/request-pw-reset`,
        { email: values.email },
        {
          headers: {
            'Content-Type': 'application/json',
          }
        }
      );
      showToast('Reset Link sent. Please check your inbox', { type: 'success' });
    } catch (error: any) {
      if (error.response && error.response.data && error.response.data.message) {
        if (error.response.data.message === "Cannot read property 'uid' of null") {
          showToast('You have entered an invalid email', { type: 'error' });
        } else {
          showToast(error.response.data.message, { type: 'error' });
        }
      } else {
        showToast('There was an error processing your request. Please try again later.', { type: 'error' });
      }
    }
  };

  return (
    <>
      <Toaster position="top-right" />
      <div className="login-container" >
        <img
          className="login-title-main"
          src={CareHiresLogo}
          alt="CareHires Logo"
        />
        <Row justify="center" align="middle">
          <Card className="card-inline-height" style={{ height: '100%' }}>
            <Row>
              <Title level={2}>Forgot your password?</Title>
              <Text className="forgot-password-text">
                Fear Not. We’ll email you instructions to reset your password.
              </Text>
            </Row>
            <Row style={{ height: '80%' }}>
              <Form onFinish={onFinish} layout="vertical" className="forgot-password-form">

                <Form.Item
                  className="common-card-margin">
                  <Text className="placeholder-labels">Email</Text>
                </Form.Item>
                <Form.Item
                  className="common-card-margin"
                  name="email"
                  rules={[{ required: true, message: 'Please input your email!' }]}
                >
                  <Input placeholder="sample@domain.com" className="custom-input" />
                </Form.Item>

                <Form.Item className="common-card-margin">
                  <Link to="/login" className="forgot-password-link">Return to Login</Link>
                </Form.Item>
                <Form.Item
                  className="reset-password-margin">
                  <Button type="primary" htmlType="submit" block className="forgot-password-button">
                    Reset Password
                  </Button>
                </Form.Item>
              </Form>
            </Row>
          </Card>
        </Row>
      </div >
    </>
  );
};

export default ForgotPassword;
